<template>
  <div>
    <ValidationProvider :rules="rules" v-slot="validationContext">
      <b-form-group>
        <template v-slot:label>
          <span v-html="formattedLabel"></span>
        </template>
        <b-form-radio-group
          v-model="input"
          class="horizondal-radiogroup"
          :options="items"
          :disabled="disabled"
          :state="getValidationState(validationContext)"
          @change="$emit('input', input)"
        >
          <b-form-invalid-feedback
            :state="getValidationState(validationContext)"
            >{{ message(validationContext) }}</b-form-invalid-feedback
          >
        </b-form-radio-group>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    label: String,
    options: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    items() {
      if (typeof this.options != "object") return [];
      return this.options.map((item) => {
        item.text = item.name;
        return item;
      });
    },
    formattedLabel() {
      if(!this.rules) return this.label;
      if (this.rules.indexOf("required") != -1)
        return this.label + " <span style='color:red'>*</span>";
      return this.label;
    },
  },
  methods: {
    message(validationContext) {
      return validationContext.errors[0];
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  mounted() {
    if (this.value != undefined) {
      this.input = this.value.toString();
    }
  },
};
</script>

<style lang="scss">
.horizondal-radiogroup {
  display: block;
  .custom-radio {
    margin-right: 10px;
    float: left;
    .custom-control-label {
      margin-left: 10px;
    }
  }
  .invalid-feedback {
    width: 100%;
    float: left;
  }
}
</style>
